import { render, staticRenderFns } from "./PostEvent.vue?vue&type=template&id=768d738c&"
import script from "./PostEvent.vue?vue&type=script&lang=js&"
export * from "./PostEvent.vue?vue&type=script&lang=js&"
import style0 from "./PostEvent.vue?vue&type=style&index=0&id=768d738c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports